<template>
    <form @submit.prevent="save" class="clearfix pb-4">
        <top-nav-bar :goto="backPath"></top-nav-bar>

        <template v-if="step === 'information'">
            <form-group label="ID of Candidate Crew" name="id_of_candidate_crew" :required="true">
                <input type="number" name="id_of_candidate_crew" class="input" v-model="report.id_of_candidate_crew">
            </form-group>

            <form-group label="Flight No." name="flight_no" :required="true">
                <input type="text" name="flight_no" class="input" v-model="report.flight_no">
            </form-group>

            <form-group label="Date" name="date" :required="true">
                <datepicker
                        placeholder="Select date"
                        id="date"
                        name="date"
                        v-model="report.date"
                />
            </form-group>
        </template>

        <template v-if="step === 'details'">
            <h4 class="mb-8">Details</h4>

            <form-group label="Does the candidate show a positive attitude at work (towards colleagues and passengers)?"
                        name="show_attitude" :required="true">
                <select v-model="report.show_attitude" id="show_attitude" name="show_attitude" class="input" required>
                    <option v-for="yes_no_option in yes_no_options" :value="yes_no_option.value">
                        {{yes_no_option.label}}
                    </option>
                </select>
            </form-group>

            <form-group label="Does the candidate participate actively in the work flow (dedicated, teamwork etc.)?"
                        name="participate_actively" :required="true">
                <select v-model="report.participate_actively" id="participate_actively" name="participate_actively"
                        class="input" required>
                    <option v-for="yes_no_option in yes_no_options" :value="yes_no_option.value">
                        {{yes_no_option.label}}
                    </option>
                </select>
            </form-group>

            <form-group label="Does the candidate have good knowledge about company procedures?"
                        name="company_procedures" :required="true">
                <select v-model="report.company_procedures" id="company_procedures" name="company_procedures"
                        class="input" required>
                    <option v-for="yes_no_option in yes_no_options" :value="yes_no_option.value">
                        {{yes_no_option.label}}
                    </option>
                </select>
            </form-group>

            <form-group label="Does the candidate show situational awareness, effective CRM?"
                        name="show_awareness" :required="true">
                <select v-model="report.show_awareness" id="show_awareness" name="show_awareness" class="input" required>
                    <option v-for="yes_no_option in yes_no_options" :value="yes_no_option.value">
                        {{yes_no_option.label}}
                    </option>
                </select>
            </form-group>

            <form-group v-if="report.show_attitude === 0
             || report.participate_actively === 0
              || report.company_procedures === 0
               || report.show_awareness === 0"
                        label="If any of the answers above are NO please provide a short explanation"
                        name="explanation" :required="true">
                <textarea name="explanation" class="input"
                          id="explanation" rows="10"
                          v-model="report.explanation" required>
                </textarea>
            </form-group>

            <form-group
                    label="Would you recommend this candidate to be offered an extended or permanent position within the company?"
                    name="recommend_extended" :required="true">
                <select v-model="report.recommend_extended" id="recommend_extended" name="recommend_extended"
                        class="input" required>
                    <option v-for="yes_no_option in yes_no_options" :value="yes_no_option.value">
                        {{yes_no_option.label}}
                    </option>
                </select>
            </form-group>

            <form-group label="Any additional comments"
                        name="additional_comment">
                <textarea name="additional_comment" class="input"
                          id="additional_comment" rows="10"
                          v-model="report.additional_comment">
                </textarea>
            </form-group>
        </template>

        <div class="block md:inline-flex md:float-right">
            <button class="btn btn--colored__blue w-full" type="submit" v-html="buttonText"></button>
        </div>
    </form>
</template>

<script>
    import InteractsWithDates from '@/mixins/InteractsWithDates';
    import NeedsUsers from '@/mixins/NeedsUsers';
    import HasSteps from '@/mixins/HasSteps';
    import IsReport from '@/mixins/IsReport';
    import SetsReportData from '@/mixins/SetsReportData';

    export default {
        mixins: [InteractsWithDates, NeedsUsers, HasSteps, IsReport, SetsReportData],

        data() {
            return {
                type: 'performance-review',
                steps: [
                    {name: 'Information', id: 'information'},
                    {name: 'Details', id: 'details'},
                ],
                yes_no_options: [
                    {value: '', label: '–'},
                    {value: 1, label: 'Yes'},
                    {value: 0, label: 'No'},
                ],
                report: {
                    id_of_candidate_crew: '',
                    flight_no: '',
                    date: '',
                    show_attitude: '',
                    participate_actively: '',
                    company_procedures: '',
                    show_awareness: '',
                    explanation: '',
                    recommend_extended: '',
                    additional_comment: ''
                }
            }
        },

        created() {
            if (this.$parent.reportData) {
                this.setData(this.$parent.reportData, ['flight_no', 'date']);
                this.setData(this.$parent.reportData.content, ['id_of_candidate_crew']);
                this.setData(this.$parent.reportData.content, [
                    'show_attitude', 'participate_actively', 'company_procedures',
                    'show_awareness', 'explanation', 'recommend_extended', 'additional_comment'
                ], 'details');
            }
        },
    }
</script>

<style>
    /* For Firefox */
    input[type='number'] {
        -moz-appearance: textfield;
    }

    /* Webkit browsers like Safari and Chrome */
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>
